import { Injectable, Inject } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import _moment from 'proxies/dayjs';
import { Router } from '@angular/router';
import { DialogService } from '../../dialog/dialog.service';
import { PopUIEngineComponent } from '../../pop-uiengine/pop-uiengine.component';
import { DialogModalSize } from '../../dialog/dialog-ref';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { DashboardService } from './dashboard.service';
import { StorageService } from 'src/modules/base/shared/services/storage.service';
const moment = _moment;
declare var Chart:any;
@Injectable()
export class ChartService {

    public static CACHE_THRESHOLD = 8.64e+7;
    public CACHE_THRESHOLD_LABEL = "24Hr";
    public static CATCHE_ALLOWED_COMPONENTS = ["bar","pie","doughnut"];
    constructor(private baseService:BaseService,private appService:AppService,private alertService:AlertsService, private router: Router, public dialogService: DialogService, public dashboardService: DashboardService,public storageService:StorageService) {
        
    }
    checkIfCached(item){
        return (item.component != undefined && ChartService.CATCHE_ALLOWED_COMPONENTS.indexOf(item.component)>-1) && (item["time_period"] != undefined && item["widget_id"] != undefined && item["interval"] != undefined);
    }
    loadChartData(item,callback){
        if(this.checkIfCached(item)){
            var key = this.getChartKey(item);
            this.storageService.getData(key,(obj)=>{
                let FUTURE_THRESHOLD = new Date().getTime() + ChartService.CACHE_THRESHOLD;
                if(obj && obj.data != undefined && obj.data.time != undefined && obj.data.time <= FUTURE_THRESHOLD){
                    obj.data.isCached = true;
                    callback(obj.data);               
                }else{
                    this.loadChartDataFn(item,callback);
                }
            })
                        
        }else{
            this.loadChartDataFn(item,callback);
        }
    }

    isCached(config){
        return (config.isCached != undefined && config.isCached);
    }

    loadChartDataFn(item,callback){

        var args = '';
        
        if(item.args != undefined && item.args != ''){
                args = item.args;
        }

        var filter = '';
        if(item.filter != undefined && item.filter != ''){
            filter = item.filter;
        }
        var resource = item.resource;
        if(item.isMongoQueryEnable != undefined && item.isMongoQueryEnable){
            resource = "report_summary";
        }
        var key = this.getChartKey(item);
        var isCached = this.checkIfCached(item)

        this.baseService.get(item.query_id, args, resource, item.application,filter).subscribe((res) => {
            if(res.errCode != -1 && res.resource != undefined && res.resource.length){
                var tempChartData = res.resource[0];
                var chartData:any = false;
                let allPromiseObj: any = [];
                let allPromiseTempObj: any = [];
                var conversionMap = {
                    "true":"YES",
                    "false":"NO" 
                }
                if(tempChartData.datasets != undefined && tempChartData.datasets.length > 0){
                    for (let index = 0; index < tempChartData.datasets.length; index++) {
                        let dataSet = tempChartData.datasets[index];
                        if(dataSet.label != undefined && Object.keys(conversionMap).indexOf(dataSet.label.toLowerCase())>-1){
                            dataSet.label = conversionMap[dataSet.label.toLowerCase()];
                        }
                        
                    }
                }
                    if(item.component != undefined && (item.component == 'doughnut' || item.component == 'pie') && tempChartData.datasets.length > 0){
                        if(tempChartData.datasets != undefined){
                            var newLabel = [];
                            var newDataset = [];
                        
                            for(let dataset of tempChartData.datasets) {
                                var k = 0;
                                for(let label of tempChartData.labels) {
                                    newLabel.push(label+"~"+dataset.label);
                                    if(dataset.data[k] != undefined){
                                        newDataset.push(dataset.data[k]);
                                    }else{
                                        newDataset.push(0);
                                    }
                                
                                    k++;
                                }
                            }
                            var allChartData:any = {chartData:[{label:"",data:newDataset}],chartLabels:newLabel};
                            if(isCached){   
                                key = this.getChartKey(item);
                                this.cacheChartData(key,{data:allChartData})
                            }
                            callback(allChartData);
                        }else{
                            var allChartData:any = {};
                            if(isCached){  
                                this.cacheChartData(key,{data:allChartData})
                            }
                            callback(allChartData);
                        }
                        return;
                    }else if(item.component != undefined && (item.component == 'count')){

                        if(res && res.resource != undefined && res.resource.length > 0){
                            var tempData = res.resource[0];
                            if(res.resource[0]["total_value"] != undefined){
                                //nothing to do
                            }else if(tempData.datasets != undefined && tempData.datasets.length>0){
                              var total= 0;
                              for(let dataset of tempData.datasets) {
                                if(dataset.data != undefined){
                                    var datasetData = dataset.data;
                                    for(let dta of datasetData) {
                                        total +=  dta;
                                    }
                                }
                                
                              }
                              res.resource[0]["total_value"] =  total;
                            }else{
                              if(tempData.datasets != undefined &&  tempData.datasets[0] != undefined){
                                res.resource[0]["total_value"] =  tempData.datasets[0].data[0];
                              }else{
                                res.resource[0]["total_value"] =  0;
                              }
                            }
                            if(res.resource[0]["total_value"] != undefined){
                                var allChartData:any = res.resource[0]["total_value"];
                                if(isCached){  
                                    var key = this.getChartKey(item);
                                    this.cacheChartData(key,{data:allChartData})
                                }
                                callback(allChartData);
                            }else{
                                var allChartData:any = 0;
                                if(isCached){  
                                    this.cacheChartData(key,{data:allChartData})
                                }
                                callback(allChartData);
                            }
                        }else{
                            var allChartData:any = 0;
                            if(isCached){ 
                                this.cacheChartData(key,{data:allChartData})
                            }
                            callback(allChartData);
                        }

                    }else if(item.component != undefined && (item.component == 'bar' || item.component == 'line')){
                        if(tempChartData.datasets != undefined && tempChartData.datasets.length > 0){
                            var chartDataSets = tempChartData.datasets;
                            var chartLabels = tempChartData.labels;

                            var allChartData:any = {chartDataSets:chartDataSets,chartLabels:chartLabels};
                            if(isCached){    
                                key = this.getChartKey(item);
                                this.cacheChartData(key,{data:allChartData})
                            }
                            callback(allChartData);
                        }else{
                            var allChartData:any = 0;
                            if(isCached){  
                                this.cacheChartData(key,{data:allChartData})
                            }
                            callback(allChartData);
                        }
                    }else{
                        if(tempChartData.datasets != undefined){
                            var i = 0;                       
                            chartData = [];
                            var i = 0;
                            for(let dataset of tempChartData.datasets) {
                                delete dataset.id;
                               chartData.push(dataset);
                               i++;
                            }
                            var allChartData:any = {chartData:chartData,chartLabels:tempChartData.labels};
                            if(isCached){   
                                key = this.getChartKey(item);
                                this.cacheChartData(key,{data:allChartData})
                            }
                            callback(allChartData);
                        }else{
                            var allChartData:any = 0;
                            if(isCached){  
                                this.cacheChartData(key,{data:allChartData})
                            }
                            callback(allChartData);
                        }
                    }
            }else{
                var allChartData:any = 0;
                if(isCached){   
                    this.cacheChartData(key,{data:allChartData})
                }
                callback(allChartData);
            }

           
        }, err => {
            callback({});
        });
    }

    cacheChartData(key,data){
        if(data.data != undefined && data.data != '0'){
            data.data["time"] = new Date().getTime()
            this.storageService.setData(key,data,()=>{})
        }
    }

    getChartKey(item){
        var facilityId = this.appService.getCurrentFacilityID();
        console.log(facilityId);
        if(facilityId){
            return item["time_period"]+"_"+item["interval"]+"_"+item["widget_id"]+"_"+facilityId;
        }else{
            return item["time_period"]+"_"+item["interval"]+"_"+item["widget_id"];
        }
        
    }

    getChart(datasource,labels,callback){
        var item:any = {};
        item.chart_datasource = datasource;
        item.chart_datasource = datasource;
        item.chartLegend = '';
        item.chartType = '';
        item.labels = labels;
        this.loadChartData(item, callback);
    }


    prepareArgs(item, args) {
        var backgroundColor = [];
        var label = 'labels';
        if (item.component != undefined && (item.component == 'doughnut' || item.component == 'pie')) {
            // label = 'xaxis_labels';
            
        }
        //TODO: check if need to generate dyanamic args from labels or it is coming from datasource already
        if (item.labels_data != undefined && item.labels_data.length) {
            //for all values * support
            if(item.labels_data[0].value == '*'){
                label = "keys";
                str_arg = item.labels_data[0].label_key;
            }else{
                var str_arg = '';
                let i = 0;
                for (let key of item.labels_data) {
                    if (i > 0) {
                        str_arg += '__';
                    }
                    str_arg += key.label_key + '~' + key.value+'~'+key.labels;
                    // if(item.component != undefined && item.component == 'doughnut'){
                        backgroundColor.push(key.backgroundColor);
                    // }
                    i++;
                }
            }
            

            args += ((args == '') ? '' : ',') + label + ':' + str_arg;
        }
        return args
    }

    chartClick(evt: any,array:any,kxChart:any,data:any,chartType:any): void {
        if(kxChart != undefined && kxChart.chart != undefined && kxChart.chart.getElementAtEvent != undefined){
    
            var dataChart = kxChart.chart.getElementAtEvent(evt);
            if(dataChart != undefined && dataChart.length && dataChart[0] != undefined &&  dataChart[0]._model != undefined){
              if(data != undefined && data.is_drilldown_available != undefined && data.is_drilldown_available && data.labels_data != undefined && data.labels_data.length && data.time_period != undefined && data.time_period){
                if(chartType == "bar" || chartType == "" ){
                  var drillData = {...data};
                  drillData["time_period"] = data.time_period;
                  drillData["chart_label"] = dataChart[0]._model.datasetLabel;
                  drillData["chart_value"] = dataChart[0]._model.label;
                  drillData["interval"] = data.interval;
                  this.getDrilldown(drillData);
                
                  }else{
                    this.alertService.info("Please switch to bar chart to see the drilldown.")
                  }
              }
            }
          
         }
    }
    getDrilldown(data,returnData:any=false) {
       
            try{
                var filterData = {};
                var args = "time_period:"+data.time_period;
                args += ",widget_id:"+data.id;
                args += ",filterType:"+data.filterType;
                if(data.filterType == "custom"){
                    args += ",from:"+data.from;
                    args += ",to:"+data.to;
                }
                if(data.chart_label != undefined){
                    args += ",chart_label:"+data.chart_label;
                }
                if(data.chart_value != undefined){
                    args += ",chart_value:"+data.chart_value;
                }
                if(data.interval != undefined){
                    args += ",interval:"+data.interval;
                }
                if(data.drill_resource != ""){
                    this.baseService.getResourceDef(data.drill_resource,(def)=>{
                        def = JSON.parse(JSON.stringify(def));
                        if(def.list != undefined && def.list.fields != undefined){
                            data["encryptedfieldArray"] = [];
                            var resourceDef = this.getBasicResource();
                            if(def.config == undefined){
                                def.config = {};
                            }
                            def.config = {...def.config,...resourceDef.config};//      
                            delete def.list.complex_search;                     
                            delete def.list.filter;                     
                            let fieldArray = [];
                            for (let i = 0; i < def.list.fields.length; i++) {
                                let nameList = def.list.fields[i].name.split(',');
                                fieldArray.push(nameList[0]);//fixing in case name has comma
                                def.list.fields[i].name = "extra_data."+def.list.fields[i].name;
                            }
                            if(def.encrypted_keys != undefined && def.encrypted_keys.length > 0){ 
                                
                                data["encryptedfieldArray"] = [...def.encrypted_keys];
                                
                                // for (let i = 0; i < def.encrypted_keys.length; i++) {
                                //     def.encrypted_keys[i] = "extra_data."+def.encrypted_keys[i];
                                // }
                                //Saving directly into json def (not a good way for dynamic json generated decryption)
                                var reportDef = (this.appService._appData.JSON_DEF["report_summary"] != undefined)?this.appService._appData.JSON_DEF["report_summary"]:{};
                                reportDef["encrypted_keys"] = def.encrypted_keys;
                                this.appService._appData.JSON_DEF["report_summary"] = reportDef;
                            }
                            data["fieldArray"] = fieldArray;
                            if(def.list != undefined && def.list.projectionKeys != undefined){
                                var projectionKeys = this.baseService.getProjectionKeys( def.list.fields, def.list.projectionKeys);
                                if(projectionKeys.length>0){
                                    data["fieldArray"] = data["fieldArray"].concat(projectionKeys);
                                }
                            }
                           
                        }
                        
                        if(returnData){
                            let tempData = this.openDrillResource(data,args,filterData,def,true);
                            returnData(tempData);
                        }else{
                            this.openDrillResource(data,args,filterData,def,false);
                        }
                        
                    });
                }else{
                    var resourceDef = this.getBasicResource();
                    resourceDef.resource = data.resource;
                    var drilConfig =  JSON.parse(data.drill_query); 
                    if(drilConfig.fields != undefined && Object.keys(drilConfig.fields).length>0){                        
                        let i = 0;
                        for(let fieldName in drilConfig.fields){
                            resourceDef.list.fields.push({ 
                                    "heading": drilConfig.fields[fieldName],
                                    "order": i ,
                                    "sortable": false,
                                    "name": "extra_data."+fieldName
                            });
                            i++;
                        }
                        
                        if(returnData){
                            let tempData = this.openDrillResource(data,args,filterData,resourceDef,true);
                            returnData(tempData);
                        }else{
                            this.openDrillResource(data,args,filterData,resourceDef,false);
                        }
                        
                    }else{
                        throw new Error();
                    }
                }
                
               
                
                   
                    
            }catch(e){
                this.alertService.error("Invalid Drill Config");
            }
      }

      getBasicResource(){
          return JSON.parse('{ "resource": "", "config": { "projection_keys":false,"first_action":"list","hideSearchBox":true,"add_required": false, "table": true, "tile": false,"taggable":false,"show_title":true, "noCount":1}, "page_name": { }, "list": { "fields": [ ] } }');
      }

      prepareChartPayload(filterType,data){
        let argsArr = []
        data.query_id = data.query_id ? data.query_id : 'GET_CHART_QUERY'
        argsArr.push('time_period:' + (filterType =='fixed' ? data.time_period : filterType))
        argsArr.push('widget_id:' + data.id)
        if (data.interval != undefined && data.interval != '')
        argsArr.push('interval:' + (filterType =='fixed' ? data.interval : filterType))
        if (filterType =='custom' && data.from != null && data.to != null)
        argsArr.push('from:' + data.from + ',to:' + data.to)
        data.args = argsArr.join(',')
        // let args = this.chartService.prepareArgs(this.data, argsArr.join(','))
        data.component = data.type;
        return data;
      }
      

      openDrillResource(data,args,filterData,resourceDef,returnData=false){
            if(resourceDef && resourceDef.page_name == undefined){
                resourceDef.page_name = {};
            }
            if(data["fieldArray"] != undefined){
                args += ",fields:"+data["fieldArray"].join("__");
            }

            if(data["encryptedfieldArray"] != undefined){
                args += ",encrypted_fields:"+data["encryptedfieldArray"].join("__");
            }
            resourceDef.page_name.list = data.widget_name+" Details";
            resourceDef.list.APIresource = {
                "datasource": {
                    "resource": "report_summary",
                    "application": "bireports",
                    "query_id": "GET_PAGE_QUERY",
                    "args": args
                }
            };
            resourceDef.list.print_allowed = ["refresh"];
            var i = 0;
            
            filterData["resourceDef"] = resourceDef;
            console.log("resourceDef===>",resourceDef);
        
        
        
        if(!returnData){
            this.dialogService.open(PopUIEngineComponent, { size: DialogModalSize.Lg ,data:filterData}).afterClosed.subscribe(
                response => {
                console.log("popup is closed")
                this.router.navigate([])
                })
        }else{
            return filterData;
        }
      }

      getAllIntervals(){
          return ['daily', 'weekly', 'monthly', 'quarterly'];
      }
      getIntervalList(data) {
        var intervals;
        switch (data.time_period) {
          case 'current_year':
          case 'past_year': intervals = this.getAllIntervals();
            break;
          case 'current_quarter':
          case 'past_quarter': intervals = ['daily', 'weekly', 'monthly'];
            break;
          case 'current_month':
          case 'past_month': intervals = ['daily', 'weekly'];
            break;
          case 'current_week':
          case 'past_week': intervals = ['daily'];
            break;
          default: intervals = this.getAllIntervals();
            break;
        }
        return intervals;
      }
      intervalsBasedOnCustomRange(filterType){
        if(filterType == 'fixed'){
            return this.getAllIntervals();
        }else{
            return ['daily'];
        }
      }

      valueChange(e,q,data){
        console.log(e,q,'e,q')
        data.from = e.FROM;
        data.to = e.TO;
        if(data.from!=null && data.to!=null)
        {
         let diff = (data.to-data.from)/86400000
         this.intervalsBasedOnCustomRange(diff)
         data.from = moment(data.from).format("YYYY-MM-DD");  
         data.to = moment(data.to).format("YYYY-MM-DD");   
          return data;
        }
        
        return false;
      }

      getTimePeriod(callback){
        this.baseService.get('get_valueset_by_id_flat', 'resourceId:dash_time_period,system:karexpert', 'valueset', 'system-management').subscribe(response => {
            callback(response.resource);
          })
      }

      getWidget(data,callback){
        this.dashboardService.getWidgetData(data.widget_id,(res) => {
            if (res) {
              data = { ...data, ...res };
              data.component = data.type
                var chartOptions = {
                  "responsive": true,
                  "aspectRatio":2.3,
                  "legend": {
                    "position":data.rows>5?"right":"top",
                    "display": true
                  },
                  tooltips: {
                    yAlign: "center",
                    xAlign: 'center'
                  },
                  "hover": {
                    "animationDuration": 0
                  },
                  "animation": {
                    "duration": 1,
                    "onComplete": function() {
                        var barWidth = 15;
                        var chartInstance = this.chart,
                        ctx = chartInstance.ctx;
                        try{
                            var metaC = chartInstance.controller.getDatasetMeta(0);
                            barWidth = metaC.data[0]._model.width
                        }catch(e){

                        }
                        
                        if(data.type == 'bar' && this.chart.config.type == 'bar' && barWidth>=5){
                           
                    
                            ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
                            ctx.textAlign = 'center';
                            ctx.textBaseline = 'bottom';
                            ctx.fillStyle =  "#000000";
                            this.data.datasets.forEach(function(dataset, i) {
                                var meta = chartInstance.controller.getDatasetMeta(i);
                                meta.data.forEach(function(bar, index) {
                                var data = dataset.data[index];
                                if(data != "0"){
                                    ctx.fillText(data, bar._model.x, bar._model.y);
                                }
                                });
                            });
                        }
                    }
                  },
                };
              if(data.config){
                if(data.config.time_period)
                data.time_period = data.config.time_period;
                if(data.config.interval)
                data.interval = data.config.interval;
              }
              callback({data:data,chartOptions:chartOptions});
            }else{
                callback({data:{},chartOptions:{}});
            }
          })
      }
}
